export default "__VITE_ASSET__fbbb1b65__"